import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { Sponsor } from 'src/app/catalogs/catalogs.model';

@Component({
  selector: 'app-promotion-exchanged-modal',
  templateUrl: './promotion-exchanged-modal.page.html',
  styleUrls: ['./promotion-exchanged-modal.page.scss']
})
export class PromotionExchangedModalPage {
  @Input() points = 0;
  @Input() banner: string;
  @Input() sponsor: Sponsor;

  constructor(private modalCtrl: ModalController, private router: Router) {}

  goToRewards() {
    this.modalCtrl.dismiss().then(() => this.router.navigateByUrl('rewards'));
  }

  onClose() {
    this.modalCtrl.dismiss();
  }
}
